import { render, staticRenderFns } from "./attendancetypeLimit.vue?vue&type=template&id=993f95c4"
import script from "./attendancetypeLimit.vue?vue&type=script&lang=js"
export * from "./attendancetypeLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports